export * from './objects-selector.component';
export * from './objects-selector.module';
